import type { Product } from '../core/types/catalog'
import { euro, rating } from '../core/format/currency'
import { plural } from '../core/format/text'

/**
 * Alle toegankelijke namen van de winkel op één plek (aria-labels, alt-teksten,
 * schermlezer-teksten). Ze worden opgebouwd uit de productdata, zodat ze kloppen
 * voor elk product dat straks van de server komt. Pas een zin hier aan, niet in een component.
 */
export const shopLabels = {
  skipToContent: 'Direct naar de inhoud',
  close: 'Sluiten',
  newTab: '(opent in een nieuw tabblad)',
  /** Achter elke "App Sarah"-link: waar hij heen gaat en dat hij een nieuw tabblad opent. */
  viaWhatsApp: ' via WhatsApp (opent in een nieuw tabblad)',
  /** Zonder bestelnummer (nog niet betaald of nog niet bekend): nooit het technische id tonen. */
  orderNumberLater: 'Je bestelnummer volgt in de bevestigingsmail.',
  menu: (open: boolean) => (open ? 'Menu sluiten' : 'Menu openen'),

  cart: (count: number) => (count > 0 ? `Winkelmand, ${plural(count, 'product', 'producten')}` : 'Winkelmand, leeg'),

  /** Alt-tekst: eerst wat in de mediabibliotheek staat, anders merk + naam (+ inhoud). */
  productImage: (p: Product) =>
    p.imageAlt?.trim() || [p.brand, p.name, p.volume].filter(Boolean).join(' '),

  addToCart: (p: Product) => `${p.name} van ${p.brand} in winkelmand, ${euro(p.price)}`,
  soldOut: (p: Product) => `${p.name} is tijdelijk uitverkocht`,
  /** Het korte label bij een uitverkocht product of protocol. */
  soldOutShort: 'Tijdelijk uitverkocht',
  /** Na "toevoegen", achter de productnaam (voor schermlezers en de koopbalk). */
  addedToCart: 'zit in je winkelmand',
  /** Onder een protocol waarvan een deel uitverkocht is. */
  partlySoldOut: (n: number) => `${n === 1 ? 'Eén product is' : `${n} producten zijn`} tijdelijk uitverkocht; de rest gaat in je winkelmand.`,
  remove: (p: Product) => `${p.name} verwijderen uit winkelmand`,
  fewer: (p: Product) => `Eén ${p.name} minder`,
  more: (p: Product) => `Eén ${p.name} meer`,
  quantity: (p: Product, qty: number) => `${p.name}: ${qty} in winkelmand`,
  lineQty: (qty: number) => `${qty}×`,

  rating: (p: Product) => `Beoordeeld met ${rating(p.rating)} van 5, ${plural(p.reviews, 'beoordeling', 'beoordelingen')}`,

  gridLoading: 'De collectie wordt geladen',
  results: (n: number) => (n === 0 ? 'Geen producten gevonden' : `${plural(n, 'product', 'producten')} gevonden`),
} as const
